<template>
    <div class="service-product-item" :class="{
        'service-product-item--with-content': hasSlotContent,
    }">
        <div class="service-product-item__title-bar">
            <h3 class="service-product-item__title">
                {{ name }}
            </h3>
            <span class="service-product-item__price" :class="{ 'service-product-item__price--hidden': cost === null }">
                <span v-if="!$scheme.priceless">{{ costDisplay }}</span>
            </span>
            <add-remove-button
                class="service-product-item__action"
                :is-added="inBasket"
                :disabled="disabled"
                @add="$emit('add')"
                @remove="$emit('remove')" />
        </div>
        <div v-if="hasSlotContent">
            <slot />
        </div>
    </div>
</template>

<script>

import MathTools from '@/helpers/math-tools'
import AddRemoveButton from './add-remove-button'

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        cost: {
            type: Number,
            required: false,
            default: null,
        },
        inBasket: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        /**
         * Returns true if the component has a default slot with content.
         * @returns {boolean}
         */
        hasSlotContent() {
            return !!this.$slots.default
        },

        /**
         * Returns a string representation of a currency value.
         * @returns {string}
         */
        costDisplay() {
            return this.cost ? MathTools.segmentCurrency(this.cost) : 'Free'
        },
    },

    components: {
        AddRemoveButton,
    },
}

</script>

<style lang="scss">

.service-product-item {
    position: relative;
    margin-bottom: $wide-gutter;

    @include element('title-bar') {
        display: grid;
        column-gap: 1em;
        margin-bottom: $base-gutter;
        grid-template-columns: 3fr 1fr 1fr;
    }

    @include element('title') {
        font-size: 1.2rem;
        font-weight: normal;
    }

    @include element('price') {
        font-size: 1.2rem;
        text-align: right;

        @include modifier('hidden') {
            visibility: hidden; // so as not to mess up the grid
        }
    }

    @include modifier('with-content') {
        padding-bottom: 60px;

        .service-product-item__title-bar {
            grid-template-columns: 3fr 1fr;

            @include bp-min-mid {
              grid-template-columns: 3fr 1fr 1fr;
            }
        }

        .service-product-item__action {
            position: absolute;
            bottom: $wide-gutter;
            right: 0;

            @include bp-min-mid {
              position: static;
            }
        }
    }
}

</style>
